export const VALUE_CONFLICT_ROLES = ['financial'];

export const MARGIN_EXCEPTION_ROLES = ['admin', 'financial'];

export const PRICE_EDIT_ROLES = ['financial'];

export const PACKAGE_PAGE_ROLES = ['admin', 'financial', 'seller'];

export const BALANCE_BLOCK_ROLES = ['financial'];

export const VOUCHER_RESERVATION_CANCEL_ROLES = ['admin', 'operator', 'financial', 'marketing'];

export const VOUCHER_CREATE_ROLES = ['admin', 'operator'];

export const hasAnyRole = (roles = [], allowed = []) => roles.some((role) => allowed.includes(role?.name || role));
